
import moment from "moment";
import { eventHandler, translations } from "@/mixins";
import Translations from "../components/Translations.vue";
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Promotion, Coupon } from "@/services/SOLO";
import CouponGroupsCreateModal from '@/views/Admin/pages/Promotions/components/CouponGroupsCreateModal';
import CouponGroupCollapse from "../components/CouponGroupCollapse.vue";

@Component({
  components: {
    CouponGroupsCreateModal,
    Translations,
    CouponGroupCollapse
  },
  mixins: [eventHandler, translations]
})
export default class CouponGroupsList extends Vue {
  hasList: boolean = true;
  couponGroups: Array<any> = [];
  openCreate: boolean = false
  filter: any = {
    name: '',
  }
  translate!: Function;
  confirm!: Function
  $notify: any;

  created() {
    this.loadCouponsGroup();
  }

  onNew() {
    this.openCreate = true;
  }

  handleClose(value: any) {
    this.openCreate = value;
  }

  applyFilter(data: any) {
    this.filter.name = data.name;
    this.loadCouponsGroup();
  }

  reset() {
    this.filter.name = '';
    this.loadCouponsGroup();
  }

  loadCouponsGroup() {
    Coupon.allCouponsGroup(1, this.filter.name).then(response => {
      this.couponGroups = response.data.data;
    });
  }

  onEditGroup(coupon: any) {
    this.$router.push({
      path: `/coupon-groups/coupon-list/${coupon.id}`,
    });
  }

  onDeleteGroup(coupon: any) {
    let message = this.translate("Are you sure you want to delete this coupon ") + coupon.attributes.name

    this.confirm(this.$bvModal, `${message}?`).then(
      (value: boolean) => {
        if(value) {
          Coupon.deleteCouponsGroup(coupon.id).then(() => {
            this.loadCouponsGroup()

            this.$notify({
              title: 'Deleting Success',
              verticalAlign: 'bottom',
              horizontalAlign: 'left',
              message: `Coupon Deleted Successfully`,
              type: "success",
              icon: "fas fa-check"
            });
          }).catch((err) => {
            this.$notify({
              title: "SYSTEM ERROR!",
              verticalAlign: "bottom",
              horizontalAlign: "left",
              message: "Something went wrong, please try again!",
              type: "danger",
              icon: "fas fa-bomb",
            });
          });
        }
      }
    );
  }

  formatDate(date: Date) {
    return moment
      .utc(date)
      .locale("en-us")
      .local()
      .format("ll");
  }
}
